import React from 'react'
import styled from 'styled-components'
import ServiceSequence from '../../components/kiosk/KioskContent/ServiceSequence/ServiceSequence'
import {useUIDispatch} from '../../context/UIContext'
import {DASHBOARD, LOGON_CONTAINER} from '../../constants/const'

const StyledContainer = styled.div`
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
`
const EquipmentQR = ({eqId}) => {
  const uiDispatch = useUIDispatch()

  const onHeaderAction = ({type}) => {
    if (type === 'CANCEL') {
      // Ignore the CANCEL option. The EQUIPMENT view is set in the SERVICE_SEQUENCE
    }

    if (type === 'SIGN_ON') {
      uiDispatch({type: 'setContent', payload: {content: LOGON_CONTAINER}})
    }

    if (type === 'HOME') {
      uiDispatch({type: 'setContent', payload: {content: DASHBOARD}})
    }
  }
  return (
    <StyledContainer>
      <ServiceSequence
        isEquipmentQR
        eqId={eqId}
        onHeaderAction={onHeaderAction}
      />
    </StyledContainer>
  )
}

export default EquipmentQR

EquipmentQR.defaultProps = {
  isEquipmentQR: false
}
